import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    message: '',
    type: 1, // 1 - visitor, 2 - supporter
    avatar: '',
    time: '',
    loading: true,
    read: false,
    showAvatar: true
  },

  initialize(props, o) {
    this.config = o || {};
    const type = this.get('type');
    const avatar = this.get('avatar');
    const defaultAvatar = `${this.config.domain}img/default.png`;
    if (type !== 1 && (!avatar || avatar === '')) {
      this.set('avatar', defaultAvatar);
    }
  }
});
